import gql from 'graphql-tag';
import moment from 'moment';

import actionTypes from './constants';
import * as functions from './functions';

// -----------------------------------------------------------------------------
// SUBSCRIPTIONS (GRAPHQL)
// -----------------------------------------------------------------------------
export const loadPaymentSchedule = (variables) => (dispatch) => {
  const paymentSchedule = functions.calculatePaymentSchedule(variables);
  return dispatch({
    type: actionTypes.LOAD_PAYMENT_SCHEDULE,
    payload: {
      paymentSchedule,
    },
  });
};
/* */
export const loadSubscriptions = (client, variables, fetchPolicy = 'no-cache') => async (dispatch) => {
    try {
      const prevSubscription = await client.query({
        query: gql`
          ${actionTypes.gql.GET_LAST_SUBSCRIPTION}
        `,
        fetchPolicy,
        variables,
      });
      if (!prevSubscription || !prevSubscription.data.getLastSubscription) {
        return null;
      }
      const fromDate = moment().subtract('7', 'd').format('YYYY-MM-DD');
      const nextSubscription = await client.query({
        query: gql`
          ${actionTypes.gql.GET_SUBSCRIPTION}
        `,
        fetchPolicy,
        variables: { ...variables, from: fromDate },
      });
      let paymentSchedule;
      if (nextSubscription && nextSubscription.data.getSubscription) {
        const isUGolf = variables.golfNetwork && variables.golfNetwork === 1;
        const {
          installments,
          membershipPackage: { membership, products },
        } = nextSubscription.data.getSubscription;
        const productsAmount = products ? products.reduce((acc, p) => acc + p.amount, 0) : 0;
        if (installments.length > 0) {
          paymentSchedule = installments.map(({ amount, dueDate }) => ({ amount, dueDate }));
        } else {
          paymentSchedule = functions.calculatePaymentSchedule({
            scheduledAmount: membership.amount,
            additionalAmountOnFirstInstallment: productsAmount,
            dayOfMonth: isUGolf ? 5 : 15,
            firstInstallmentDate: isUGolf ? null : moment('2022-01-15'),
            ...nextSubscription.data.getSubscription,
          });
        }
      }
      return dispatch({
        type: actionTypes.LOAD_SUBSCRIPTION,
        payload: {
          prevSubscription: prevSubscription.data.getLastSubscription,
          nextSubscription: nextSubscription.data.getSubscription,
          paymentSchedule,
        },
      });
    } catch (err) {
      return dispatch({
        type: actionTypes.NO_SUBSCRIPTION,
        payload: err.message,
      });
    }
  };

/* */
export const noSubscriptions = () => (dispatch) => dispatch({
    type: actionTypes.NO_SUBSCRIPTION,
  });
